// @ts-strict-ignore
import React from 'react'
import ExternalLink from 'components/ExternalLink'
import InfoMessage from 'components/InfoMessage'
import { graphql } from 'relay-runtime'
import { PreloadedQuery, usePreloadedQuery } from 'react-relay'
import { VanityUrlMessage_Query } from '__generated__/VanityUrlMessage_Query.graphql'
import { useQueryParams } from 'hooks/router'

export const VanityUrlMessageQuery = graphql`
  query VanityUrlMessage_Query($userId: ID!) {
    user: node(id: $userId) {
      ... on User {
        self
        status
        profile {
          openToOpportunities
          slug
        }
        jobApplications: freelancerJobApplications(filters: { statuses: [job_application_draft] }) {
          totalCount
        }
      }
    }
  }
`

interface IVanityUrlProps {
  preloadedQuery: PreloadedQuery<VanityUrlMessage_Query>

  /** @deprecated instead, simply don't render this component in lite mode at all */
  liteMode?: boolean
}

function VanityUrlMessage({ preloadedQuery, liteMode }: IVanityUrlProps) {
  const data = usePreloadedQuery(VanityUrlMessageQuery, preloadedQuery)
  const user = data?.user
  const isPending = user?.status === 'pending'
  const isSelf = Boolean(user?.self)
  const query = useQueryParams()
  const isApplyingToJob = Boolean(query?.job) || user?.jobApplications?.totalCount > 0

  if (!isSelf) return null

  if (isApplyingToJob && !user.profile?.openToOpportunities) {
    return (
      <InfoMessage data-cy="closed-to-opportunities">
        Your profile is currently set to closed to opportunities. To complete your job application, set your profile to open to opportunities.
      </InfoMessage>
    )
  }

  if (liteMode) return null

  if (isPending) {
    return (
      <InfoMessage data-cy="private-profile">
        Your profile will not be publicly visible until you submit it
      </InfoMessage>
    )
  }

  if (user?.profile?.openToOpportunities) {
    return (
      <InfoMessage data-cy="public-profile">
        Share your profile with the world at <ExternalLink href={`flexhire.com/${user.profile.slug}`} />
      </InfoMessage>
    )
  }

  return null
}

export default React.memo(VanityUrlMessage)
